import { motion } from 'framer-motion';

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.55, delay: i * 0.08, ease: [0.2, 0.8, 0.2, 1] } }),
};

export const Reveal = ({ children, className = '', delay = 0, ...rest }) => (
  <motion.div className={className} variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-60px' }} custom={delay} {...rest}>
    {children}
  </motion.div>
);

export const Orbs = ({ variant = 'hero' }) => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
    {variant === 'hero' ? (
      <>
        <div className="orb orb-indigo animate-float w-[520px] h-[520px] -top-40 -left-32" />
        <div className="orb orb-cyan animate-float-slow w-[460px] h-[460px] top-10 right-[-120px]" />
        <div className="orb orb-magenta animate-float w-[360px] h-[360px] bottom-[-160px] left-1/3" style={{ opacity: 0.35 }} />
      </>
    ) : (
      <>
        <div className="orb orb-cyan animate-float-slow w-[380px] h-[380px] -top-32 right-0" style={{ opacity: 0.3 }} />
        <div className="orb orb-magenta animate-float w-[320px] h-[320px] bottom-[-120px] -left-20" style={{ opacity: 0.25 }} />
      </>
    )}
    <div className="absolute inset-0 bg-grid" />
  </div>
);

export const SectionTitle = ({ eyebrow, title, sub, align = 'left' }) => (
  <Reveal className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
    {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-3">{eyebrow}</p>}
    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold tracking-tight leading-[1.05]">{title}</h2>
    {sub && <p className="text-base md:text-lg text-muted-foreground mt-4 leading-relaxed">{sub}</p>}
  </Reveal>
);
